import { Reveal, SectionHeading } from "./Reveal";
import SectorGroups from "./SectorGroups";
import { useLanguage } from "@/i18n";

export default function Consulenza() {
    const { t } = useLanguage();

    return (
        <section
            id="consulenza"
            data-testid="consulenza-section"
            className="relative scroll-mt-20 border-t border-navy-600"
        >
            <div className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32">
                <SectionHeading
                    chapter={t.consulenza.chapter}
                    eyebrow={t.consulenza.eyebrow}
                    title={t.consulenza.title}
                    testid="consulenza-heading"
                />

                <div className="border-t border-navy-600">
                    {t.consulenza.items.map((s, i) => (
                        <Reveal key={s.number} delay={i * 0.04}>
                            <div
                                data-testid={`consulenza-row-${i + 1}`}
                                className="group grid gap-6 border-b border-navy-600 py-10 transition-colors hover:bg-navy-800 lg:grid-cols-12 lg:items-center lg:gap-8 lg:px-4"
                            >
                                <div className="lg:col-span-2">
                                    <span className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">
                                        {t.consulenza.rowLabel}
                                    </span>
                                    <p className="mt-1 font-display text-4xl font-bold text-[#C9D8EC] lg:text-5xl">
                                        {s.number}
                                    </p>
                                </div>
                                <div className={s.tags ? "lg:col-span-6" : "lg:col-span-10"}>
                                    <h3 className="font-display text-2xl font-semibold tracking-tight text-slate-50 sm:text-3xl">
                                        {s.title}
                                    </h3>
                                    <p className="mt-3 text-base leading-relaxed text-slate-400">{s.desc}</p>
                                </div>
                                {s.tags && (
                                    <div className="flex flex-wrap gap-2 lg:col-span-4 lg:justify-end">
                                        {s.tags.map((tag) => (
                                            <span
                                                key={tag}
                                                className="border border-navy-600 bg-navy-950 px-3 py-1 font-mono text-[10px] uppercase tracking-widest text-slate-400"
                                            >
                                                {tag}
                                            </span>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </Reveal>
                    ))}
                </div>

                <div className="mt-16 lg:mt-20">
                    <SectorGroups testid="consulenza-sector-groups" />
                </div>
            </div>
        </section>
    );
}
